/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datasets_Agents_EmptyInputs */



/**
* | output |
* | --- |
* | "No agent you can see uses this dataset yet." |
*
* @param {Datasets_Agents_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_agents_empty = /** @type {((inputs?: Datasets_Agents_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Agents_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch kein für Sie sichtbarer Agent nutzt diesen Datensatz.")
	return /** @type {LocalizedString} */ ("No agent you can see uses this dataset yet.")
});